<script lang="ts">
import { defineComponent, PropType } from 'vue'
import StepLayout from './StepLayout.vue'
import ButtonSubmit from '@/components/button/ButtonSubmit.vue'
import InputCompanyName from '@/components/lead/InputCompanyName.vue'
import InputFormDepartmentAndPosition from '@/components/lead/InputFormDepartmentAndPosition.vue'
import InputFormPhoneNumber from '@/components/lead/InputFormPhoneNumber.vue'
import ValidationObserver from '@/components/validation/ValidationObserver.vue'
import validationOperator from '@/models/validationOperator'

export default defineComponent({
  name: 'CorporateInfoStep',

  components: {
    StepLayout,
    ValidationObserver,
    ButtonSubmit,
    InputCompanyName,
    InputFormDepartmentAndPosition,
    InputFormPhoneNumber,
  },

  props: {
    namespace: {
      type: String,
      required: true,
    },

    companyName: {
      type: Object as PropType<InputText>,
      required: true,
    },

    corporateZipcode: {
      type: Object as PropType<InputText>,
      required: true,
    },

    corporateAddress1: {
      type: Object as PropType<InputText>,
      required: true,
    },

    corporateAddress2: {
      type: Object as PropType<InputText>,
      required: true,
    },

    corporateNumber: {
      type: Object as PropType<InputText>,
      required: true,
    },

    corporateEmployeeNum: {
      type: Object as PropType<InputNumber>,
      required: true,
    },

    departmentAndPosition: {
      type: Object as PropType<InputText>,
      required: true,
    },

    phoneNumber: {
      type: Object as PropType<InputText>,
      required: true,
    },
  },

  emits: [
    'update:companyName',
    'select:companyLeadInfo',
    'update:departmentAndPosition',
    'update:phoneNumber',
    'click:prev',
    'click:next'
  ],

  setup(props, { emit }) {
    const { validationObserver, validate } = validationOperator()

    const next = () => {
      emit('click:next')
    }

    return {
      // data
      validationObserver,

      // computed

      // methods
      validate,
      next,
    }
  },
})
</script>

<template>
  <StepLayout
    :required="true"
    @click:prev="$emit('click:prev')">
    <template #title>
      お勤め先について教えて下さい
    </template>
    <template #caption>
      全ての項目を入力して下さい
    </template>
    <template #description>
      <ValidationObserver
        ref="validationObserver"
        :namespace="namespace"
        @valid="next">
        <div class="l-rows">
          <!-- 勤務先名 -->
          <div class="l-rows--row">
            <InputCompanyName
              :model-value="companyName.value"
              :corporate-zipcode="corporateZipcode"
              :corporate-address1="corporateAddress1"
              :corporate-address2="corporateAddress2"
              :corporate-number="corporateNumber"
              :corporate-employee-num="corporateEmployeeNum"
              :namespace="namespace"
              :name="companyName.name"
              :validation-scheme="companyName.validationScheme"
              @update:model-value="$emit('update:companyName', $event)"
              @select:company-lead-info="$emit('select:companyLeadInfo', $event)" />
          <!-- /.l-rows row --></div>

          <!-- 部署・役職正式名称 -->
          <div class="l-rows--row">
            <InputFormDepartmentAndPosition
              :department-and-position="departmentAndPosition"
              :namespace="namespace"
              @update:model-value="$emit('update:departmentAndPosition', $event)" />
          <!-- /.l-rows row --></div>

          <!-- 電話番号 -->
          <div
            v-if="phoneNumber"
            class="l-rows--row">
            <InputFormPhoneNumber
              :model-value="phoneNumber.value"
              :namespace="namespace"
              :name="phoneNumber.name"
              :validation-scheme="phoneNumber.validationScheme"
              @update:model-value="$emit('update:phoneNumber', $event)">
              <template #secondary>
                <div class="o-note__general u-text__small u-margin__smaller">
                  <ul class="o-note__general--items">
                    <li class="o-note__general--item">登録内容の確認が必要な場合のみご連絡します。営業目的の電話ではありません。</li>
                    <li class="o-note__general--item">実際に連絡可能な電話番号を半角数字で入力してください。入力例で示されている番号は使用できません。</li>
                  </ul>
                <!-- /.o-note__general --></div>
              </template>
            </InputFormPhoneNumber>
          <!-- /.l-rows row --></div>
        <!-- /.l-rows --></div>

        <ButtonSubmit
          :is-link="false"
          :has-shadow="false"
          :width="384"
          prevent
          stop
          @click:submit="validate">
          次へ
        </ButtonSubmit>
      </ValidationObserver>
    </template>
  </StepLayout>
</template>
